import { ShieldCheck } from '@orgus/ui/icons';
import { CopyButton, cn } from '@orgus/ui';

/**
 * A quiet line where a machine's ceiling refuses work: what to allow, and the exact command to
 * run on that computer, with a copy button. The console cannot raise a ceiling itself, so this
 * is the whole way on.
 */
export function CeilingHint({ command, lead = 'On that computer, allow it once:', className }: { command: string; lead?: string; className?: string }) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-2', className)} data-ceiling-hint="">
      <p className="flex items-center gap-2 text-caption text-fg-muted">
        <ShieldCheck className="size-3.5 shrink-0 text-fg-subtle" aria-hidden />
        {lead}
      </p>
      <div className="flex min-w-0 items-center gap-2 rounded-control border border-border bg-sunken py-1 pl-3 pr-1">
        <code className="min-w-0 flex-1 truncate font-mono text-caption text-fg" title={command}>
          {command}
        </code>
        <CopyButton text={command} label="Copy command" />
      </div>
    </div>
  );
}
